import React from "react";
import dayjs from "dayjs";
import { Layout, Typography } from "antd";

const { Footer } = Layout;

const FooterBar = () => {
  const displayYear = dayjs().year();

  return (
    <Footer
      className="border-t border-black/10 bg-surface-page text-center text-black/65"
      data-testid="app-footer"
    >
      <Typography.Text className="text-black/65">
        © {displayYear} Dreams & Goals
      </Typography.Text>
    </Footer>
  );
};

export default FooterBar;
